import React, { useEffect, useState, useRef } from 'react';
import { Form, OverlayTrigger, Modal, Spinner, ButtonGroup, Tooltip } from 'react-bootstrap';
import { Button, Row, Col, Label, CardHeader, Card, CardBody } from 'reactstrap';
import Axios from 'axios';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import readXlsxFile from 'read-excel-file';
import { Backspace, Save2Fill, Star, FiletypeXlsx } from 'react-bootstrap-icons';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import dateformat from 'dateformat';
import common from '../../commonData';
import { ProductList } from './cardadd';

var count = 0;

function AddCommandeFrs({ show, setIsSave, setMsg, setMsgravity, setLoad, handleClose, setLoading, load, loading }) {
    var ladate = new Date();
    const [codeart, setCodeart] = useState([]);
    const [article, setArticle] = useState([]);
    const [fournisseur, setFournData] = useState([]);
    const [listeSelect, setListeSelect] = useState([]);
    const [articles, setArticleData] = useState([]);
    const [famille, setfamilleData] = useState([]);
    const [famille_id, setIdFamille] = useState('');

    const [states, setState] = useState({
        fournisseur_id: '',
        dateCommande: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
        datePrevLivr: '',
        observation: ''
    });
    const { fournisseur_id, dateCommande, datePrevLivr, observation } = states;

    const history = useHistory();
    const typeaheadModel = useRef(null);

    useEffect(() => {
        if (!localStorage.getItem('user-info')) {
            history.push('/login');
        }
        (async function anyNameFunction() {
            setLoad(true);
            const getarticle = Axios.get(common.ipapi + '/api/article/indexall/' + common.societe);
            const getClient = Axios.get(common.ipapi + '/api/fournisseur/all');
            const getFamille = Axios.get(common.ipapi + '/api/famille/indexstep');
            await Axios.all([getarticle, getClient, getFamille])
                .then(
                    Axios.spread((...responses) => {
                        setArticle(responses[0].data);
                        setArticleData(responses[0].data);
                        setFournData(responses[1].data);
                        setfamilleData(responses[2].data);
                        setLoad(false);
                    })
                )
                .catch((errors) => {
                    setLoad(false);
                });
        })();
    }, [history]);

    function setFamilleId(d) {
        setIdFamille(d.length > 0 ? d[0].id : 0);
        if (d.length > 0) {
            const res = article.filter((element) => element.famille_id == d[0].id);
            setArticle(res);
        } else {
            setArticle(articles);
        }
    }

    function setCodearts(codeart) {
        setCodeart(codeart);
        if (codeart.length > 0) {
            codeart.forEach((ent, index) => {
                function search(d) {
                    return d.id === ent.id;
                }
                const del = listeSelect.find(search);
                if (del === undefined) {
                    let t = [];
                    let d = {
                        id: codeart[0].id,
                        qrbarre: codeart[0].qrbarre,
                        quantite: 1,
                        prix: codeart[0].prixvente,
                        descriptionart: codeart[0].descriptionart || codeart[0].descriptionartfr
                    };
                    t.push(d);
                    t = t.concat(listeSelect);
                    setListeSelect(t);
                    setCodeart([]);
                } else {
                    setIsSave(true);
                    setMsgravity('primary');
                    setMsg('A été déjà ajouter à la liste');
                    setCodeart([]);
                }
            });
        }
    }

    const subTotal = listeSelect.reduce((total, product) => {
        return (
            total +
            (product.quantite * product.prix - product.quantite * product.prix * (product.remise / 100)) +
            (product.quantite * product.prix - product.quantite * product.prix * (product.remise / 100)) * 0.18
        ); //total + product.prixprestation * +product.qte;
    }, 0);
    const onChangeProductQuantity = (index, event) => {
        const value = event.target.value;
        const cloneProducts = [...listeSelect];
        cloneProducts[index].quantite = value;
        setListeSelect(cloneProducts);
    };

    const onChangePrestation = (index, event) => {
        const value = event.target.value;
        const cloneProducts = [...listeSelect];
        cloneProducts[index].descriptionart = value;

        setListeSelect(cloneProducts);
    };

    const onRemoveProduct = (i, id) => {
        var filteredProduct = [];
        setLoad(true);
        filteredProduct = listeSelect.filter((product, index) => {
            return index != i;
        });
        setListeSelect(filteredProduct);
        setMsg('Ligne supprimée');
        setMsgravity('info');
        setIsSave(true);
        setLoad(false);
    };

    function saveCommande(values) {
        if (!navigator.onLine) {
            setMsg('Veuillez vérifier votre connexion internet');
            setMsgravity('info');
            setIsSave(true);
            return;
        }
        setLoad(true);
        if (listeSelect.length === 0) {
            setMsg('Veuillez saisir au moin une prestation');
            setMsgravity('info');
            setIsSave(true);
            setLoad(false);
            return false;
        }

        let text = 'Voulez-vous confirmer cette action';
        let res = window.confirm(text);
        if (res === false) {
            return;
        }
        var formData = new FormData();
        formData.append('datecommande', values.datecommande);
        formData.append('datelivraisonprevu', values.dateprevlivr);
        formData.append('observation', values.observation);
        formData.append('codeart', JSON.stringify(listeSelect));
        formData.append('user_id', common.userid);
        formData.append('fournisseur_id', values.fournisseur_id);
        formData.append('societe', common.societe);
        Axios({
            url: common.ipapi + '/api/commandefrs/store',
            method: 'POST',
            data: formData
        })
            .then((res) => {
                if (res.status !== 200) {
                    setMsg('Veuillez vérifier votre connexion internet');
                    setMsgravity('info');
                    setIsSave(false);
                    return;
                }
                if (res.data.status) {
                    setCodeart([]);
                    setListeSelect([]);
                    setMsg(res.data.msg);
                    setMsgravity('info');
                    setIsSave(true);
                    count++;
                    setLoading(!loading);
                    setLoad(false);
                    handleClose();
                } else {
                    setMsg("Une erreur c'est produite veuillez verifier les données saisies");
                    setMsgravity('danger');
                    setIsSave(true);
                    setLoad(false);
                }
            })
            .catch((error) => {
                setIsSave(true);
                setMsgravity('danger');
                setLoad(false);
            });
    }

    function groupBy(tableauObjets) {
        let t = [];
        return tableauObjets.reduce(function (res, value) {
            if (value[0] !== '') {
                t.push({
                    id: value[0],
                    qrbarre: value[1],
                    quantite: value[3],
                    descriptionart: value[2],
                    model: value[4],
                    marque: value[5]
                });
            }
            return t;
        }, {});
    }
    function setLoadFile(files) {
        var data;
        setLoad(true);
        readXlsxFile(files[0]).then((rows) => {
            data = groupBy(rows);
            setListeSelect(data);
        });
        setLoad(false);
    }

    return (
        <>
            <Modal show={load} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    Veuillez patienter.......
                    <Spinner animation="grow" variant="warning" />
                </Modal.Body>
            </Modal>
            <Formik
                initialValues={{
                    fournisseur_id: fournisseur_id,
                    datecommande: dateCommande,
                    dateprevlivr: datePrevLivr,
                    observation: observation
                }}
                enableReinitialize
                validationSchema={Yup.object().shape({
                    fournisseur_id: Yup.number().required(common.msg),
                    datecommande: Yup.date().required(common.msg)
                })}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        saveCommande(values);
                        setSubmitting(false);
                    } catch (err) {
                        setMsg('Une erreur à eu lieu');
                        setMsgravity('danger');
                        setIsSave(true);
                        setLoad(false);
                    }
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, values, setFieldValue, setFieldTouched }) => (
                    <Modal show={show} fullscreen={true}>
                        <Form noValidate onSubmit={handleSubmit}>
                            <Modal.Header>
                                FAIRE UNE COMMANDE AUPRES D'UN FOURNISSEUR
                                <Backspace onClick={handleClose} color="red" size={30} />
                            </Modal.Header>
                            <Modal.Body>
                                <div id="lightbody">
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    Fournisseur <Star color="red" size={10} />
                                                </Form.Label>
                                                <Col sm={8}>
                                                    <Typeahead
                                                        id="fournisseur_id"
                                                        multiple={false}
                                                        onChange={(selected) => {
                                                            const value = selected.length > 0 ? selected[0].id : 0;
                                                            setFieldValue('fournisseur_id', value);
                                                        }}
                                                        onInputChange={(text, event) => setFieldValue('fournisseur_id', text)}
                                                        onBlur={(e) => setFieldTouched('fournisseur_id', true)}
                                                        labelKey="nomfourn"
                                                        options={fournisseur}
                                                        selected={fournisseur.slice(
                                                            fournisseur.findIndex((element) => element.id === values.fournisseur_id),
                                                            fournisseur.findIndex((element) => element.id === values.fournisseur_id) + 1
                                                        )}
                                                    />
                                                    {errors.fournisseur_id && <div id="feedback">{errors.fournisseur_id}</div>}
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm={4}>
                                                    Date commande <Star color="red" size={10} />
                                                </Form.Label>
                                                <Col sm={5}>
                                                    <Form.Control
                                                        id="datecommande"
                                                        type="date"
                                                        placeholder="Date commande"
                                                        aria-describedby="inputGroupPrepend"
                                                        size="sm"
                                                        value={values.datecommande}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                    {errors.datecommande && <div id="feedback">{errors.datecommande}</div>}
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm="4">
                                                    Date livraison
                                                </Form.Label>
                                                <Col sm="5">
                                                    <Form.Control
                                                        id="dateprevlivr"
                                                        type="date"
                                                        placeholder="Date livraison prévisionnelle"
                                                        aria-describedby="dateliv"
                                                        size="sm"
                                                        value={values.dateprevlivr}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label column sm="4">
                                                    Observation
                                                </Form.Label>
                                                <Col sm="8">
                                                    <Form.Control
                                                        id="observation"
                                                        as="textarea"
                                                        placeholder="Observation"
                                                        aria-describedby="inputGroupPrepend"
                                                        size="sm"
                                                        value={values.observation}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        rows={6}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                        <Col md={8}>
                                            <Card>
                                                <CardHeader>Sélection des articles à facturer</CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        <Col md={2}>
                                                            <OverlayTrigger
                                                                placement="bottom"
                                                                overlay={<Tooltip id="tooltip-disabled">Importer un fichier excel</Tooltip>}
                                                            >
                                                                <Label className="custom-file-upload">
                                                                    Importer Fichier Excel
                                                                    <input
                                                                        type="file"
                                                                        accept=".xlsx, .xls"
                                                                        onChange={(e) => setLoadFile(e.target.files)}
                                                                    />
                                                                    <FiletypeXlsx color="orange" size={40} />
                                                                </Label>
                                                            </OverlayTrigger>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group as={Col} md="12" controlId="famille">
                                                                <Form.Label column sm="12">
                                                                    Famille
                                                                </Form.Label>
                                                                <Col sm="12">
                                                                    <Typeahead
                                                                        ref={typeaheadModel}
                                                                        id="my-typeahead-id"
                                                                        labelKey={(option) => `${option.libellefam}`}
                                                                        filterBy={['libellefam']}
                                                                        value={famille_id}
                                                                        options={famille}
                                                                        onChange={(cli) => setFamilleId(cli)}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={7}>
                                                            <Form.Group as={Col} md="12" controlId="validationCustomUsername">
                                                                <Form.Label column sm="12">
                                                                    Sélectionner vos articles{' '}
                                                                </Form.Label>
                                                                <Col sm="12">
                                                                    <Typeahead
                                                                        id="my-typeahead-id"
                                                                        labelKey={(option) =>
                                                                            `${option.qrbarre} / ${
                                                                                option.descriptionart || option.descriptionartfr
                                                                            } / qte (${option.qtestock})`
                                                                        }
                                                                        filterBy={['descriptionart', 'descriptionartfr', 'qrbarre']}
                                                                        selected={codeart}
                                                                        options={article}
                                                                        placeholder="Sélectionner vos articles ici"
                                                                        onChange={(codeart) => setCodearts(codeart)}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>
                                                            <ProductList
                                                                products={listeSelect}
                                                                onChangeProductQuantity={onChangeProductQuantity}
                                                                onRemoveProduct={onRemoveProduct}
                                                                onChangePrestation={onChangePrestation}
                                                                // onChangeRemise={onChangeRemise}
                                                                // onChangePrix={onChangePrix}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                {/* <Summary subTotal={subTotal} sitva={sitva} /> */}
                                <div className="ml-auto">
                                    <ButtonGroup size="sm">
                                        <Button color="danger" onClick={handleClose}>
                                            <Backspace color="#000" size={20} />
                                        </Button>
                                        <Button type="submit" variant="ligth">
                                            <Save2Fill color="#807f7e" size={20} /> Enregister
                                        </Button>
                                    </ButtonGroup>
                                </div>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                )}
            </Formik>
        </>
    );
}

export default AddCommandeFrs;
